// extracted by mini-css-extract-plugin
export var aligned = "info-panel-module--aligned--64318";
export var container = "info-panel-module--container--67057";
export var legend = "info-panel-module--legend--9f4c1";